import request from './request.js'
import requestsNoLoad from './requests.js';

// /marketplaceSetting/insert
export function insertSetting(data){
  return request({
    url: 'marketplaceSetting/insert',
    method: 'post',
    params: data
  });
}
// /marketplaceSetting/update
export function updateSetting(data){
  return request({
    url: 'marketplaceSetting/update',
    method: 'post',
    params: data
  });
}
// /marketplaceSetting/getData
export function getSettingData(data){
  return request({
    url: 'marketplaceSetting/getData',
    method: 'post',
    params: data
  });
}

// /marketplaceSetting/checkRunnable
export function checkRunnable(data){
  return request({
    url: 'marketplaceSetting/checkRunnable',
    method: 'post',
    params: data
  });
}

// /marketplaceProject/getData
export function getProjectData(data){
  return request({
    url: 'marketplaceProject/getData',
    method: 'post',
    params: data
  });
}

// /marketplaceProject/upsert
export function upsertProjectData(data){
  return request({
    url: 'marketplaceProject/upsert',
    method: 'post',
    params: data
  });
}

// /marketplace/getData
export function getMarketplaceData(data){
  return request({
    url: 'marketplace/getData',
    method: 'post',
    params: data
  });
}

// /marketplaceProject/getMarketplaceProjectData
export function getMarketplaceProjectData(data){
  return request({
    url: 'marketplaceProject/getMarketplaceData',
    method: 'post',
    params: data
  });
}

// /marketplaceProject/getOneData
export function getMarketplaceProjectOneData(data){
  return request({
    url: 'marketplaceProject/getOneData',
    method: 'post',
    params: data
  });
}

// /marketplaceProject/getOneSimpleData
export function getMarketplaceProjectOneSimpleData(data){
  return request({
    url: 'marketplaceProject/getOneSimpleData',
    method: 'post',
    params: data
  });
}

// /marketplaceProject/getMarketplaceDataForList
export function getMarketplaceDataForList(data){
  return request({
    url: 'marketplaceProject/getMarketplaceDataForList',
    method: 'post',
    params: data
  });
}

// /marketplaceProject/getMarketplaceDataForList
export function getMarketplaceDataForListNoLoad(data){
  return requestsNoLoad({
    url: 'marketplaceProject/getMarketplaceDataForList',
    method: 'post',
    params: data
  });
}

// /marketplaceProject/getMarketplaceDataForMap
export function getMarketplaceDataForMap(data){
  return request({
    url: 'marketplaceProject/getMarketplaceDataForMap',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/getApplyData
export function getMarketplaceApplyData(data){
  return request({
    url: 'marketplaceApplication/getApplyData',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/upsert
export function upsertMarketplaceApplication(data){
  return request({
    url: 'marketplaceApplication/upsert',
    method: 'post',
    params: data
  });
}


// /marketplaceApplication/insert
export function insertApplication(data){
  return request({
    url: 'marketplaceApplication/insert',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/update
export function updateApplication(data){
  return request({
    url: 'marketplaceApplication/update',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/cancel
export function cancelApplication(data){
  return request({
    url: 'marketplaceApplication/cancel',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/approve
export function approveApplication(data){
  return request({
    url: 'marketplaceApplication/approve',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/reject
export function rejectApplication(data){
  return request({
    url: 'marketplaceApplication/reject',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/toBeSign
export function toBeSignApplication(data){
  return request({
    url: 'marketplaceApplication/toBeSign',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/sendVerifyCode
export function sendVerifyCode(data){
  return request({
    url: 'marketplaceApplication/sendVerifyCode',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/verifyCode
export function verifyCode(data){
  return request({
    url: 'marketplaceApplication/verifyCode',
    method: 'post',
    params: data
  });
}

// /marketplaceLog/insert
export function insertMarketplaceLog(data){
  return request({
    url: 'marketplaceLog/insert',
    method: 'post',
    params: data
  });
}

// /marketplaceLog/getData
export function getLogData(data){
  return request({
    url: 'marketplaceLog/getData',
    method: 'post',
    params: data
  });
}

// /marketplaceAgreement/getData
export function getAgreementData(data){
  return request({
    url: 'marketplaceAgreement/getData',
    method: 'post',
    params: data
  });
}

// /marketplaceAgreement/getAgreementFile
export function getAgreementFile(data){
  return request({
    url: 'marketplaceAgreement/getAgreementFile',
    method: 'post',
    params: data
  });
}

// /marketplaceAgreement/getAgreementWithUpload
export function getAgreementWithUpload(data){
  return request({
    url: 'marketplaceAgreement/getAgreementWithUpload',
    method: 'post',
    params: data
  });
}

// /marketplaceAgreement/update
export function updateAgreement(data){
  return request({
    url: 'marketplaceAgreement/update',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/getOneData
export function getApplicationOneData(data){
  return request({
    url: 'marketplaceApplication/getOneData',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/checkRenew
export function checkRenew(data){
  return request({
    url: 'marketplaceApplication/checkRenew',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/renew
export function renew(data){
  return request({
    url: 'marketplaceApplication/renew',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/sign
export function sign(data){
  return request({
    url: 'marketplaceApplication/sign',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/removeAgreementFile
export function removeAgreementFile(data){
  return request({
    url: 'marketplaceApplication/removeAgreementFile',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/updateAgreementFile
export function updateAgreementFile(data){
  return request({
    url: 'marketplaceApplication/updateAgreementFile',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/updateFile
export function applicationUpdateFile(data){
  return request({
    url: 'marketplaceApplication/updateFile',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/removeFile
export function applicationRemoveFile(data){
  return request({
    url: 'marketplaceApplication/removeFile',
    method: 'post',
    params: data
  });
}


// /marketplaceApplication/getPendingCount
export function getMarketplacePendingCount(data){
  return request({
    url: 'marketplaceApplication/getPendingCount',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/getPendingCountByProjectID
export function getPendingCountByProjectID(data){
  return request({
    url: 'marketplaceApplication/getPendingCountByProjectID',
    method: 'post',
    params: data
  });
}

// /marketplaceApplication/getUnreadCount
export function getUnreadCount(data){
  return request({
    url: 'marketplaceApplication/getUnreadCount',
    method: 'post',
    params: data
  });
}

// marketplaceApplication/setRead
export function setRead(data){
  return request({
    url: 'marketplaceApplication/setRead',
    method: 'post',
    params: data
  });
}

// marketplaceProject/insertPageView
export function insertPageView(data){
  return request({
    url: 'marketplaceProject/insertPageView',
    method: 'post',
    params: data
  });
}




// WEBPACK FOOTER //
// ./src/api/marketplaceApi.js